<template>
  <b-modal id="modalJobInfo" ref="modalJobInfo" :title="'Status for Job #' + job.id" size="xl" ok-only @hidden="killTimer">
    <b-alert :show="message.countdown || true" fade dismissible v-for="message in messages" :key="message.text" :variant="message.variant || 'danger'">{{ message.text }}</b-alert>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <label class="col-sm-4 font-weight-bold">Title</label>
          <label class="col-sm-8">{{ job.title }}</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-sm-4 font-weight-bold">Status</label>
          <label class="col-sm-8">{{ job.status }}</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-sm-4 font-weight-bold">Started</label>
          <label class="col-sm-8">{{ formatDate(job.startTime) }}</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-sm-4 font-weight-bold">Started By</label>
          <label class="col-sm-8">{{ job.startedByFullName }} [{{ job.startedById }}]</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-sm-4 font-weight-bold">Ended</label>
          <label class="col-sm-8">{{ formatDate(job.endTime) }}</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-sm-4 font-weight-bold">Updated</label>
          <label class="col-sm-8">{{ formatDate(job.lastMessageTime) }}</label>
        </div>
      </div>
      <div class="col-md-12">
        <pre v-html="jobMessages"></pre>
      </div>
    </div>  
  </b-modal>
</template>

<script>
  export default {
    name: "generic-job-info",
    props: {
    },
    created() {
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
      this.killTimer();
    },
    watch: {
    },
    data() {
      return {
        state: window.appState,
        job: {},
        messages: [ ],
        refreshTimer: null
      };
    },
    computed: {
      jobMessages() {
        if (this.job.messages && this.job.messages.length) {
          var jobMessages = this.job.messages;
          jobMessages.reverse();
          return jobMessages.join("\n");
        } else {
          return '';
        }
      }
    },
    methods: {
      encodeUrl: appHelpers.url.encode,
      formatDate: appHelpers.formatters.formatDate,
      formatDateSansTime: appHelpers.formatters.formatDateSansTime,
      formatDateSansTimeShort: appHelpers.formatters.formatDateSansTimeShort,
      formatCurrency: appHelpers.formatters.formatCurrency,
      formatCurrencyInt: appHelpers.formatters.formatCurrencyInt,
      formatFloat: appHelpers.formatters.formatFloat,
      formatInt: appHelpers.formatters.formatInt,
      formatPercent: appHelpers.formatters.formatPercent,
      init() {
      },
      showJob(jobId) {
        appHelpers.loader.start();
        this.job = {};
        this.killTimer();
        this.getJobInfo(jobId).then(() => {
          this.initTimer();
          this.$refs.modalJobInfo.show();
        }, () => {
          this.messages = appHelpers.message.getFromResponse(response);
        });
        appHelpers.loader.stop();
      },
      hideJob() {
        this.killTimer();
        this.$refs.modalJobInfo.hide();
      },
      getJobInfo(jobId) {
        jobId = jobId || this.job.id;
        this.messages = [ ];
        if (jobId) {
          return apiClient.tracker.getJob(jobId).then((response) => {
            this.job = response.body;
          }, (response) => {
            this.messages = appHelpers.message.getFromResponse(response);
          });
        }
      },
      initTimer() {
        let self = this;
        this.refreshTimer = setInterval(self.getJobInfo, 5000);
      },
      killTimer() {
        if (this.refreshTimer) {
          clearInterval(this.refreshTimer);
        }
      }
    }
  };
</script>